module.exports = __webpack_public_path__ + "static/media/boy-1.e098715d.svg";